// js
import React from 'react';
import EngagementItem from './EngagementItem';


const EngagementCustomerItem = props => (
  <EngagementItem
    columnWidths={[5, 5, 2]}
    namePlaceholder='Customer name'
    detailsPlaceholder='Customer title'
    {...props}
  />
);

export default EngagementCustomerItem;



// WEBPACK FOOTER //
// ./src/components/analytics/EngagementCustomerItem.js